import moment from "moment"
import { useContext, useEffect, useState } from "react"
import { Card, Col, Container, Dropdown, Form, Jumbotron, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import Get from "../../api/Get"
import { 
        REPORT_APPOINTMENTONLINEACCOUNT, REPORT_APPOINTMENTONLINESPECIALITY,
        REPORT_APPOINTMENTONLINEDOCTOR,REPORT_APPOINTMENTONLINEPROVIDERSERVICE, 
        GET_SERVER_TIME, REPORT_APPOINTMENTONLINEDOCTORAVERAGE, REPORT_APPOINTMENTAVAILABILITY,
        REPORT_APPOINTMENTBYRANGE, 
        ACCOUNT_ACTIVE_ALL} from "../../api/Routes"
import AreaChartComponent from "../../components/reportes/AreaChartComponent"
import BarChartComponent from "../../components/reportes/BarChartComponent"
import CitasEncuestadasComponent from "../../components/reportes/CitasEncuestadasComponent"
import ComponentReportG2 from "../../components/reportes/ComponentReportG2"
import KpiCitasOnDemand from "../../components/reportes/KpiCitasOnDemand"
import useCompanyType from "../../hook/useCompanyType"
import { authContext } from "../../context/AuthContext"
import ReporteCitasPendientes from "../../components/reportes/ReporteCitasPendientes"
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever"
import ReporteNotificacionReasignacion from "../../components/reportes/ReporteNotificacionReasignacion"
import { getCountOnline } from "../../utils/getCountOnline"
import ReporteControlNotificacion from "../../components/reportes/ReporteControlNotificacion"

function ReportesJefeMedico({t}){
    const appointmentTypeIndicator = [
        {code: 'SCHEDULED', label: "AGENDADA"},
        {code: 'CANCELED', label: "CANCELADA"},
        {code: 'ATTENDED', label: "ATENDIDA"},
        {code: 'PENDING', label: "PENDIENTE"}
    ]
    const appointmentType = ['CUENTA', 'ESPECIALIDAD', 'DOCTOR', 'PROVEEDOR']
    const disponiblidadType = [
        {code: 'SPECIALITY', label: "ESPECIALIDAD"},
        {code: 'DOCTOR', label: "DOCTOR"},
        {code: 'PROVIDER', label: "PROVEEDOR"},
    ]

    const rangeType = [
        {code: 'SPECIALITY', label: "ESPECIALIDAD"},
        {code: 'DOCTOR', label: "DOCTOR"},
    ]
    const companyType = useCompanyType()
    const [typeReport, setTypeReport] = useState('')
    const [indicatorReport, setIndicatorReport] = useState('')
    const {auth} = useContext(authContext)    
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(false)
    const [serverTime, setServerTime] = useState(null)
    const [aveTime, setAveTime] = useState(null)
    
    const [disponibilidad, setDisponiblidad] = useState([])
    const [loadingDisp, setLoadingDisp] = useState(false)
    const [typeDisponible, setTypeDisponible] = useState('')
    const [account, setAccount] = useState('')
    const [accountOpt, setAccountOpt] = useState([])

    const [citasRange, setCitasRange] = useState([])
    const [loadingRange, setLoadingRange] = useState(false)
    const [typeRange, setTypeRange] = useState('')

    const [citasEncuestadas, setCitasEncuestadas] = useState([])
    const [citasEncuestada, setCitasEncuestada] = useState('')
    const [loadingCitasEncuestadas, setLoadingCitasEncuestadas] = useState(false)

    //server error
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //get accounts
    useEffect(()=>{
        let mounted = true
        Get({url: ACCOUNT_ACTIVE_ALL, access_token: auth.data.access_token})
        .then(response=>{
            if(mounted){
                setAccountOpt(response.data.data.response)
            }
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setAccountOpt([])
        })
        return () => mounted = false;
    }, [])
    
    useEffect(()=>{
        let mounted = true
        if(typeReport && indicatorReport){
            setLoading(true)
            let obUrl = {
                CUENTA: `${REPORT_APPOINTMENTONLINEACCOUNT}?appointmentTypeIndicator=${indicatorReport}`,
                ESPECIALIDAD: `${REPORT_APPOINTMENTONLINESPECIALITY}?appointmentTypeIndicator=${indicatorReport}`,
                DOCTOR: `${REPORT_APPOINTMENTONLINEDOCTOR}?appointmentTypeIndicator=${indicatorReport}`,
                PROVEEDOR: `${REPORT_APPOINTMENTONLINEPROVIDERSERVICE}?appointmentTypeIndicator=${indicatorReport}`,
            }
            let url = obUrl[typeReport]
            Get({url: url, access_token: auth.data.access_token})
            .then(response=>{
                if(mounted){
                    let arr = []
                    Object.keys(response.data.data.response).forEach(item=>{
                        let obj = {
                            name: item,
                            count: response.data.data.response[item].length
                        }
                        arr.push(obj)
                    })
                    setItems(arr)
                    setLoading(false)
                }            
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setLoading(false)
            })
        }else{
            setItems([])
        }    

        Get({url: GET_SERVER_TIME, access_token: auth.data.access_token})
        .then(response=>{
            if(mounted){
                setServerTime(response.data.data)                
            }            
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
        Get({url: REPORT_APPOINTMENTONLINEDOCTORAVERAGE, access_token: auth.data.access_token})
        .then(response=>{
            if(mounted){
                setAveTime(response.data.data.data)
            }  
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setAveTime(null)
        })

        return () => mounted = false;
    }, [typeReport,indicatorReport,auth.data.access_token])

    useEffect(()=>{
        let mounted = true
        if(typeDisponible && account){
            setLoadingDisp(true)
            Get({url: `${REPORT_APPOINTMENTAVAILABILITY}?type=${typeDisponible}&accountId=${account}`, access_token: auth.data.access_token})
            .then(response=>{
                if(mounted){
                    //console.log(response)
                    let arr = []
                        Object.keys(response.data.data.response).forEach(item=>{
                            let obj = {
                                name: item,
                                citas: response.data.data.response[item].length,
                                count: getCountOnline(response.data.data.response[item], typeDisponible),
                                type: typeDisponible
                            }
                            arr.push(obj)
                        })
                    setDisponiblidad(arr)
                    setLoadingDisp(false)
                }
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setLoadingDisp(false)
            })
        }else{
            setDisponiblidad([])
        }        

        return () => mounted = false;
    },[typeDisponible,  account, auth.data.access_token])

    useEffect(()=>{
        let mounted = true
        if(typeRange){
            setLoadingRange(true)
            Get({url: `${REPORT_APPOINTMENTBYRANGE}?type=${typeRange}`, access_token: auth.data.access_token})
            .then(response=>{
                if(mounted){
                    let arr = []
                    Object.keys(response.data.data.response).forEach(item=>{
                        let obj = {
                            name: item,
                            range: response.data.data.response[item]
                        }
                        arr.push(obj)
                    })
                    //console.log(arr)
                    setCitasRange(arr)
                    setLoadingRange(false)
                }
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setLoadingRange(false)
            })
        }else{
            setCitasRange([])
        }        

        return () => mounted = false;
    },[typeRange, auth.data.access_token])

    useEffect(() => {
        let mounted = true

        if(citasEncuestada){
            setLoadingCitasEncuestadas(true)
            Get({url: `${REPORT_APPOINTMENTONLINEDOCTOR}?appointmentTypeIndicator=${citasEncuestada}`, access_token: auth.data.access_token})
            .then(response=>{
                if(mounted){
                    let arr = []
                    Object.keys(response.data.data.response).forEach(item=>{
                        let obj = {
                            name: item,
                            citas: response.data.data.response[item]
                        }
                        arr.push(obj)
                    })
                    setCitasEncuestadas(arr)
                    setLoadingCitasEncuestadas(false)
                }            
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setCitasEncuestadas([])
                setLoadingCitasEncuestadas(false)
            })
        }else{
            setCitasEncuestadas([])
        }

        return () => mounted = false;
    }, [citasEncuestada, auth.data.access_token])

    return (
        <Container fluid className="my-5">
            <Row>
                <Col xs="12" md="12">
                    <h2 className="mb-0 title-top">Reportes</h2>
                </Col>
                {serverTime && <Col xs="12" md="12">
                    <div className="d-flex">
                        <div className="p-2"><span className="text-muted font-size-09rem">Zona horaria: {serverTime.timeZone}</span></div>
                        <div className="p-2"><span className="text-muted font-size-09rem">Hora actual del servidor: {moment(serverTime.currentTime, "DD/MM/YYYY HH:mm").format("HH:mm")}</span></div>
                        <div className="p-2"><span className="text-muted font-size-09rem">Desde: {serverTime.startHour}</span></div>
                        <div className="p-2"><span className="text-muted font-size-09rem">Hasta: {serverTime.finishHour}</span></div>
                    </div>
                </Col>}
            </Row>

            { aveTime!=null && 
                <Row>
                    <Col>
                        <Card className="shadow-1">
                            <Card.Body>
                                <h6 className="m-0">{`Tiempo promedio de citas: ${aveTime.toFixed(2)} min`}</h6>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            }

            <Row className="mt-3">
                <Col xs="12" md="6" className="mb-3">
                    <Card className="shadow-1">
                        <Card.Body>
                            <div className="d-flex align-items-center">
                                <div className="mr-auto"><h6>Citas por categoría</h6></div>
                                <div>
                                    <Form.Control
                                        as="select"
                                        value={typeReport}
                                        onChange={e=>setTypeReport(e.target.value)}
                                        size="sm"
                                    >
                                        <option value="">Seleccionar</option>
                                        {
                                            appointmentType.map((item, i)=>(
                                                <option value={item} key={i}>{item}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </div>
                                <div>
                                    <Form.Control
                                        as="select"
                                        value={indicatorReport}
                                        onChange={e=>setIndicatorReport(e.target.value)}
                                        size="sm"
                                        className="ml-1"
                                    >
                                        <option value="">Seleccionar</option>
                                        {
                                            appointmentTypeIndicator.map((item, i)=>(
                                                <option value={item.code} key={i}>{item.label}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </div>
                            </div>
                            <Dropdown.Divider />
                            <Row>
                                {
                                    (items.length === 0 && !loading) &&
                                    <Col xs="12" md="12">
                                        <Jumbotron>
                                            <div className="text-center">
                                                <p className="m-0">No existe información a mostrar</p>
                                            </div>
                                        </Jumbotron>
                                    </Col>                                    
                                }
                                {
                                    loading && 
                                    <Col xs="12" md="12">
                                        <div className="text-center my-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    </Col>
                                }
                                {
                                    (items.length > 0 && !loading) &&                                        
                                    <BarChartComponent data={items}/>                                    
                                }                       
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs="12" md="6" className="mb-3">
                    <Card className="shadow-1">
                        <Card.Body>
                        <div className="d-flex align-items-center">
                                <div className="mr-auto"><h6>Citas disponibles</h6></div>
                                <div>
                                    <Form.Control
                                        as="select"
                                        value={account}
                                        onChange={e=>setAccount(e.target.value)}
                                        size="sm"
                                    >
                                        <option value="">Seleccionar</option>
                                        {
                                            accountOpt.map((item, i)=>(
                                                <option value={item.id} key={i}>{item.name}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </div>                                
                                <div>
                                    <Form.Control
                                        as="select"
                                        value={typeDisponible}
                                        onChange={e=>setTypeDisponible(e.target.value)}
                                        size="sm"
                                        className="ml-1"
                                    >
                                        <option value="">Seleccionar</option>
                                        {
                                            disponiblidadType.map((item, i)=>(
                                                <option value={item.code} key={i}>{item.label}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </div>
                            </div>
                            <Dropdown.Divider />
                            {
                                    (disponibilidad.length === 0 && !loadingDisp) &&
                                    <Col xs="12" md="12">
                                        <Jumbotron>
                                            <div className="text-center">
                                                <p className="m-0">No existe información a mostrar</p>
                                            </div>
                                        </Jumbotron>
                                    </Col>                                    
                                }
                                {
                                    loadingDisp && 
                                    <Col xs="12" md="12">
                                        <div className="text-center my-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    </Col>
                                }
                                {
                                    (disponibilidad.length > 0 && !loadingDisp) &&
                                    <ComponentReportG2 data={disponibilidad}/>                            
                                }   
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs="12" md="6" className="mb-3">
                    <Card className="shadow-1">
                        <Card.Body>
                        <div className="d-flex align-items-center">
                                <div className="mr-auto"><h6>Citas por rango de duración</h6></div>
                                <div>
                                    <Form.Control
                                        as="select"
                                        value={typeRange}
                                        onChange={e=>setTypeRange(e.target.value)}
                                        size="sm"
                                    >
                                        <option value="">Seleccionar</option>
                                        {
                                            rangeType.map((item, i)=>(
                                                <option value={item.code} key={i}>{item.label}</option>
                                            ))
                                        }
                                    </Form.Control>
                                </div>
                            </div>
                            <Dropdown.Divider />
                                {
                                    (citasRange.length === 0 && !loadingRange) &&
                                    <Col xs="12" md="12">
                                        <Jumbotron>
                                            <div className="text-center">
                                                <p className="m-0">No existe información a mostrar</p>
                                            </div>
                                        </Jumbotron>
                                    </Col>                                    
                                }
                                {
                                    loadingRange && 
                                    <Col xs="12" md="12">
                                        <div className="text-center my-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    </Col>
                                }
                                {
                                    (citasRange.length > 0 && !loadingRange) &&
                                    <AreaChartComponent data={citasRange}/>                            
                                }    
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs="12" md="6" className="mb-3">
                    <Card className="shadow-1">
                        <Card.Body>
                            <div className="d-flex align-items-center">
                                <div className="mr-auto"><h6>Citas encuestadas con respuesta/sin respuesta</h6></div>                                
                                <div>
                                    <Form.Control
                                        as="select"
                                        value={citasEncuestada}
                                        onChange={e=>setCitasEncuestada(e.target.value)}
                                        size="sm"
                                        className="ml-1"
                                    >
                                        <option value="">Seleccionar</option>
                                        <option value="ATTENDED_QUALIFICATION">Citas encuestadas</option>
                                    </Form.Control>
                                </div>
                            </div>
                            <Dropdown.Divider />
                            <Row>
                                {
                                    (citasEncuestadas.length === 0 && !loadingCitasEncuestadas) &&
                                    <Col xs="12" md="12">
                                        <Jumbotron>
                                            <div className="text-center">
                                                <p className="m-0">No existe información a mostrar</p>
                                            </div>
                                        </Jumbotron>
                                    </Col>                                    
                                }
                                {
                                    loadingCitasEncuestadas && 
                                    <Col xs="12" md="12">
                                        <div className="text-center my-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    </Col>
                                }
                                {
                                    (citasEncuestadas.length > 0 && !loadingCitasEncuestadas) &&                                        
                                    <CitasEncuestadasComponent data={citasEncuestadas}/>                                    
                                }                       
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                { 
                    companyType==="mexico" &&
                    <Col xs="12" md="12" className="mb-3">
                        <KpiCitasOnDemand auth={auth} />
                    </Col>
                }
                <Col xs="12" md="12" className="mb-3">
                    <ReporteCitasPendientes auth={auth}/>
                </Col>
                <Col xs="12" md="12" className="mb-3">
                    <ReporteNotificacionReasignacion auth={auth}/>
                </Col>
                <Col xs="12" md="12">
                    <ReporteControlNotificacion auth={auth}/>
                </Col>
                
            </Row>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </Container>
    )


}

export default withTranslation()(ReportesJefeMedico)